import { motion } from 'framer-motion'
import styled from 'styled-components/macro'
import { theme } from 'styles/theme'

export const Container = styled(motion.div)`
  position: fixed;
  display: flex;
  flex-direction: column;
  left: 50%;
  bottom: 3rem;
  padding: 0 2rem;
  transform: translateX(-50%);
`

export const NotificationContainer = styled(motion.div)`
  padding: 0.6em 1em;
  margin-top: 1rem;
  color: white;
  font-weight: 600;
  color: white;
  font-size: 1.6rem;
  border-radius: 0.3em;
  box-shadow: 0 5px 10px -3px rgba(0, 0, 0, 0.3);
  background-color: ${theme.colors.accent.primary};
`
